import { Button as ButtonComponent } from 'styles/components';
import styled from 'styled-components';
export {
  ModalHeader,
  ModalContent,
  ModalBody,
  FormRow,
  FormActions,
  Button,
  ActivityIndicator,
} from 'styles/components';

//adicionar botao com disabled
export const TrashButton = styled(ButtonComponent)<{ disabled: boolean }>`
  margin-top: 30px !important;
  background-color: ${(props) => (props.disabled ? '#E9E9E9' : '#DE1745')};
  color: ${(props) => (props.disabled ? '#57575E' : '#FFFFFF')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;
